import React from "react";
import { Link } from "@/components/LocaleLink";
import { motion } from "framer-motion";
import { ArrowUpRight, Clock } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { getIndsatser } from "@/data/indsatser";
import { trackEvent, EVENTS } from "@/lib/analytics";

const IndsatsCard = ({ product, index = 0 }) => {
  const { lang } = useLang();
  const labels = getIndsatser(lang).labels;
  const { Icon } = product;

  return (
    <motion.div
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay: (index % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
    >
      <Link
        to={`/indsatser/${product.slug}`}
        onClick={() => trackEvent(EVENTS.PRODUCT_CARD_CLICK, { slug: product.slug })}
        className="group relative flex flex-col h-full rounded-3xl bg-white border border-black/5 p-7 sm:p-8 hover:-translate-y-1.5 hover:shadow-xl transition-all duration-300 overflow-hidden"
        data-testid={`indsats-card-${product.slug}`}
      >
        <span
          className="absolute top-0 left-0 h-1.5 w-full"
          style={{ backgroundColor: product.accent }}
          aria-hidden="true"
        />
        <div className="flex items-start justify-between mb-6">
          <span
            className="flex items-center justify-center h-12 w-12 rounded-2xl text-white"
            style={{ backgroundColor: product.accent }}
          >
            <Icon className="h-6 w-6" strokeWidth={1.5} />
          </span>
          {product.flagship && (
            <span className="text-[10px] uppercase tracking-[0.2em] font-semibold text-[#C47C5D] border border-[#C47C5D]/40 rounded-full px-3 py-1">
              {labels.flagship}
            </span>
          )}
        </div>

        <h3 className="font-display text-2xl sm:text-3xl text-[#1A2E24] leading-tight">
          {product.name}
          {product.subtitle && <span className="block text-lg text-[#5C7567] font-sans font-normal mt-0.5">– {product.subtitle}</span>}
        </h3>

        <p className="mt-1.5 flex items-center gap-1.5 text-sm text-[#5C7567]">
          <Clock className="h-3.5 w-3.5" /> {product.duration}
        </p>

        <p className="mt-4 text-[#3B5245] leading-relaxed flex-1">{product.summary}</p>

        <span className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-[#2D5A3F]">
          {labels.viewProduct}
          <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </span>
      </Link>
    </motion.div>
  );
};

export default IndsatsCard;
